import { Endpoint } from '@/Config/api/endpoint';
import { httpClient } from '@/Config/api/httpClient.config';
import { TopicDto } from '@/Domain/api/Conversation/dto/Topic.dto';
import { ApiMapper } from '@/Domain/mapper/App/Api.mapper';

export type TopicCreateInput = Required<Pick<TopicDto, 'topic' | 'topic_description'>>;

export class ConversationTopicsApi {
  static list = (): Promise<TopicDto[]> =>
    httpClient.get(Endpoint.conversationTopics.list).then(ApiMapper.toResponseData);

  static get = (conversationTopicId: string): Promise<TopicDto> =>
    httpClient
      .get(
        Endpoint.conversationTopics.get.replace(
          ':conversationTopicId',
          String(conversationTopicId),
        ),
      )
      .then(ApiMapper.toResponseData);

  static create = (topic: TopicCreateInput): Promise<TopicDto> =>
    httpClient.post(Endpoint.conversationTopics.create, topic).then(ApiMapper.toResponseData);

  static update = ({ id, ...topic }: TopicDto): Promise<TopicDto> =>
    httpClient
      .patch(Endpoint.conversationTopics.upload.replace(':conversationTopicId', String(id)), topic)
      .then(ApiMapper.toResponseData);

  static remove = (conversationTopicId: number): Promise<void> =>
    httpClient
      .delete(
        Endpoint.conversationTopics.delete.replace(
          ':conversationTopicId',
          String(conversationTopicId),
        ),
      )
      .then(ApiMapper.toResponseData);
}
